module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-176.c88db75.woff2";